import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';




function AppAbout() {
  return (
    <section id="about" className="block about-block">
      <Container fluid>
        <div className="title-holder ">
          <h2 >dolci</h2>
          <div className="subtitle">הקונדיטור הפרטי שלך</div>
        </div>
        <Row>
          <Col sm={6} >
            <Image src={"/img/big/324942419_901518597869884_1275714989711257874_n.webp"} />
          </Col>
          <Col className='fs-5 ' sm={6}>
            ברוכים הבאים לעולם שלנו, שבו כל עוגה היא חגיגה, וכל ביס הוא מסע של עונג. ברוכים הבאים לקונדיטוריה DOLCI.
            <p>המסע שלנו התחיל במשימה פשוטה אך עמוקה: להפוך את החוויה היומיומית של עוגה למשהו מרהיב באמת.</p>
            <p className='dis'>ב-DOLCI קונדיטוריה, אנו מאמינים בקסם הטעמים ובאומנות האפייה. כל יצירה שלנו היא יצירת מופת, מעוצבת עם המרכיבים הטובים ביותר ותשוקה בלתי מעורערת למצוינות. אנחנו לא רק אופים עוגות; אנחנו יוצרים זיכרונות, פרוסה מענגת בכל פעם.</p>
          <p className='dis'>צוות הקונדיטורים המיומנים שלנו מביאים שפע של ניסיון ויצירתיות לשולחן, ומבטיחים שכל עוגת DOLCI תהיה לא רק מהממת מבחינה ויזואלית אלא גם פיצוץ של טעמים. מהמועדפים הקלאסיים ועד לשילובים חדשים וחדשניים, התפריט שלנו הוא עדות למחויבות שלנו למצוינות קולינרית ולחדשנות. אנו מתגאים בקייטרינג לפלטה מגוונת, ומבטיחים שתהיה עוגה מושלמת לכל אירוע ולכל טעם.</p>
<p className='dis'>ב-DOLCI, אנו גם מבינים את החשיבות של מגע אישי. זו הסיבה שאנו מציעים שירותים בהתאמה אישית, המאפשרים לך להתאים את העוגה שלך למפרט המדויק שלך. בין אם זה מסר מיוחד, עיצוב ייחודי או פרופיל טעמים ספציפי, הצוות שלנו עובד בשיתוף פעולה הדוק איתך כדי להגשים את החזון שלך. עם DOLCI, כל חגיגה הופכת לחוויה בלתי נשכחת, מלאה בשמחה, אהבה והעוגות המענגות ביותר.</p>
          </Col>
         
        </Row>
      </Container>
    </section>
  );
}

export default AppAbout;